import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "card",
  style: {"width":"28rem"}
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center tittle-card" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times fs-4" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "s-obrigatorio"
}
const _hoisted_11 = ["placeholder", "name", "onUpdate:modelValue", "required"]
const _hoisted_12 = {
  key: 0,
  class: "col-sm-12 mb-5 pt-2"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-down" }, null, -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-up" }, null, -1)
const _hoisted_17 = { class: "d-flex d-flex flex-row-reverse pt-5" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary",
  style: {"margin-left":"15px"}
}, " Aplicar ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputCustom = _resolveComponent("InputCustom")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDropDownAndCancel && _ctx.closeDropDownAndCancel(...args))),
          class: "btn btn-icon btn-danger"
        }, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("form", {
        class: "form needs-validation",
        novalidate: "",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field, index) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            key: index,
            class: "row mb-5"
          }, [
            _createElementVNode("div", _hoisted_8, [
              (field.type == 'text')
                ? (_openBlock(), _createElementBlock("label", _hoisted_9, [
                    _createTextVNode(_toDisplayString(field.label) + " ", 1),
                    (field.required)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, "*"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (field.type == 'text')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 1,
                    type: "text",
                    class: "form-control",
                    placeholder: field.label,
                    name: field.name,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.result[index].value) = $event),
                    required: field.required || false
                  }, null, 8, _hoisted_11)), [
                    [_vModelText, _ctx.result[index].value]
                  ])
                : _createCommentVNode("", true),
              (field.type == 'textDate')
                ? (_openBlock(), _createBlock(_component_InputCustom, {
                    key: 2,
                    placeholder: field.label,
                    name: field.name,
                    pattern: _ctx.validacoes.INTEIRO_MAIOR_1900,
                    mask: '0000',
                    modelValue: _ctx.result[index].value,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.result[index].value) = $event),
                    required: field.required || false
                  }, null, 8, ["placeholder", "name", "pattern", "modelValue", "onUpdate:modelValue", "required"]))
                : _createCommentVNode("", true),
              (field.type == 'select')
                ? (_openBlock(), _createBlock(_component_InputSelect, {
                    key: 3,
                    label: field.label,
                    name: field.name,
                    options: 
                field.options?.map((opt) => ({
                  value: opt.value,
                  label: opt.text || opt.nome,
                }))
              ,
                    modelValue: _ctx.result[index].value,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.result[index].value) = $event),
                    required: field.required || false,
                    disabled: field.disabled || false,
                    onChange: ($event: any) => (_ctx.onChangeSectionInputSelect($event, field.name))
                  }, null, 8, ["label", "name", "options", "modelValue", "onUpdate:modelValue", "required", "disabled", "onChange"]))
                : _createCommentVNode("", true),
              (field.type == 'select-search')
                ? (_openBlock(), _createBlock(_component_Multiselect, {
                    key: 4,
                    class: "select-search",
                    modelValue: _ctx.result[index].value,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.result[index].value) = $event),
                    placeholder: "Selecione uma das opções",
                    options: field.options,
                    searchable: true,
                    disabled: field.disabled || false,
                    onChange: ($event: any) => (_ctx.onChangeSectionMultiselect($event, field.name)),
                    required: field.required || false
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled", "onChange", "required"]))
                : _createCommentVNode("", true),
              (field.type == 'select-search-on-sync')
                ? (_openBlock(), _createBlock(_component_Multiselect, {
                    key: 5,
                    class: "select-search",
                    modelValue: _ctx.result[index].value,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.result[index].value) = $event),
                    placeholder: 
                field.placeholder ? field.placeholder : 'Digite para pesquisar'
              ,
                    "resolve-on-load": false,
                    delay: 0,
                    options: field.options,
                    searchable: true,
                    disabled: field.disabled || false,
                    onChange: ($event: any) => (_ctx.onChangeSectionMultiselect($event, field.name)),
                    required: field.required || false
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "options", "disabled", "onChange", "required"]))
                : _createCommentVNode("", true)
            ])
          ])), [
            [_vShow, _ctx.showFieldByIndex(index)]
          ])
        }), 128)),
        (_ctx.fields.length > 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("span", {
                class: "btn btn-light-primary w-100",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMoreOptions()))
              }, [
                (_ctx.data.more_options)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                      _createTextVNode(" Mais Opções "),
                      _hoisted_14
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_15, [
                      _createTextVNode(" Menos Opções "),
                      _hoisted_16
                    ]))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearAndClose && _ctx.clearAndClose(...args))),
            class: "btn btn-danger"
          }, " Limpar ")
        ])
      ], 32)
    ])
  ]))
}